import React from "react";
import styles from "./HardwareSoftware.module.css";
const HardwareSoftware = () => {
  const kitItems = [
    {
      name: "IRL Robotics Kit",
      image: require("../../../../src/assets/images/robotics/Regular/img18.jpg"),
      description: "IRL Robotics Robotics Kit",
    },
    {
      name: "Competition Mat",
      image: require("../../../../src/assets/images/robotics/Regular/img12.jpg"),
      description: "4 feet by 6 feet IRL Competition mat",
    },
    {
      name: "LEGO Brick Set",
      image: require("../../../../src/assets/images/robotics/Regular/img14.jpg"),
      description: "IRL Brick set for mission model construction on mat",
    },
    {
      name: "STEM Training",
      image: require("../../../../src/assets/images/robotics/Regular/img16.jpg"),
      description: "STEM Engineer Training for 2 - 3 months",
    },
  ];

  const demoMats = [
    {
      name: "Junior Demo Mat",
      image: require("../../../../src/assets/images/robotics/Regular/img229.jpg"),
      description: "IRL Junior Category Demo Mat",
    },
    {
      name: "Senior Demo Mat",
      image: require("../../../../src/assets/images/robotics/Regular/img231.jpg"),
      description: "IRL Senior Category Demo Mat",
    },
  ];

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>
        Team's receive <span className={styles.highlight}>IRL</span> kit &
        Trainings post Registration
      </h2>
      <p className={styles.subtitle}>(For 3 months*)</p>

      <div className={styles.kitContainer}>
        {kitItems.map((item, index) => (
          <div key={index} className={styles.kitItem}>
            <img src={item.image} alt={item.name} className={styles.kitImage} />
            <p className={styles.kitDescription}>{item.description}</p>
          </div>
        ))}
      </div>

      <h3 className={styles.matTitle}>IRL Demo Mats</h3>
      <div className={styles.matContainer}>
        {demoMats.map((mat, index) => (
          <div key={index} className={styles.matItem}>
            <img src={mat.image} alt={mat.name} className={styles.matImage} />
            <p className={styles.matDescription}>{mat.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HardwareSoftware;
